import React from 'react';
import styled from 'styled-components';
import styles from './Images.module.scss'
import SideBar from './components/SideBar';
import shadows from './shadows.png';
import lakes from './lakes.png';
import yellow from './yellow.png';
import balloons from './balloons.png';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';
import { FiArrowRightCircle, FiArrowLeftCircle } from 'react-icons/fi';
import { HiOutlinePhotograph } from 'react-icons/hi';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useParams
} from "react-router-dom";
import { GrCaretPrevious } from 'react-icons/gr';
import { getNodeText } from '@testing-library/react';

const data = {
    'yellow': {
        image: yellow,
        title: 'yellow',
        subtitle: 'yellow',
        text: 'yellow',
        previous: '/images/shadows',
        next: '/images/lakes'
    },
    'lakes': {
        image: lakes,
        title: 'lakes',
        subtitle: 'lakes',
        text: 'lakes',
        previous: '/images/yellow',
        next: '/images/shadows'
    },
    'shadows': {
        image: shadows,
        title: 'shadows',
        subtitle: 'shadows',
        text: 'shadows',
        previous: '/images/lakes',
        next: '/images/balloons'
    },

    'balloons': {
        image: balloons,
        title: 'balloons',
        subtitle: 'balloons',
        text: 'balloons',
        previous: '/images/shadows',
        next: '/images/yellow'
    }
}

export function Images() {

    let { id } = useParams();

    function getImage(id) {
        return data[id].image;
    }
    function getPrevious(id) {
        return data[id].previous;
    }
    function getNext(id) {
        return data[id].next;
    }
    function getTitle(id) {
        return data[id].title;
    }
    function getSubtitle(id) {
        return data[id].subtitle;
    }
    function getText(id) {
        return data[id].text;
    }
    return (
        <div>
            <Container fluid>
                <Row>
                    <Col sm={4} md={8} md={{ span: 6, offset: 2 }}>
                        <div className={styles.container}>
                            <img className={styles.images} src={getImage(id)}></img>
                        </div>
                        <Row>
                            <Col md={{ span: 6, offset: 0 }}><Card.Text>
                                <Link className={styles.prevnext} to={getPrevious(id)}>
                                    <FiArrowLeftCircle />
                                </Link>
                                <Link className={styles.prevnext} to={getPrevious(id)}>
                                    <FiArrowRightCircle />
                                </Link>
                            </Card.Text></Col>
                        </Row>
                    </Col>
                    <Col sm={8} md={4}>
                        <Card border="white" className={styles.cardcontainer}>
                            <Card.Body className={styles.card}>
                                <Card.Title>{getTitle(id)}</Card.Title>
                                <Card.Subtitle className="mb-2 text-muted">{getSubtitle(id)}</Card.Subtitle>
                                <Card.Text>
                                    {getText(id)}
                                </Card.Text>
                                <div className={styles.gallerybuttoncontainer}>
                                    <Link to='/gallery'>
                                        <HiOutlinePhotograph className={styles.gallerybutton} />
                                    </Link>
                                </div>
                            </Card.Body>
                        </Card></Col>
                </Row>
            </Container>
        </div>
    );
}




